var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPromos = function SvgPromos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.657 67.207"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    d: "m18.669 56.208-2.744 2.743-3.512-3.513-.951.952a5.87 5.87 0 0 1-4.117 1.735h-.06a5.74 5.74 0 0 1-5.753-5.812A5.88 5.88 0 0 1 3.268 48.2l.95-.95-3.511-3.517 9.406-9.406 25.511 25.511-6.663 6.662Zm-5.882-24.675 6.51-17.265L45.39 40.362l-17.265 6.509Zm5.82-23.423 5.92-5.921 12.374 12.374.95-.951a5.88 5.88 0 0 1 4.118-1.736 5.7 5.7 0 0 1 4.131 1.681 5.84 5.84 0 0 1-.054 8.248l-.951.951 12.374 12.376-5.921 5.92Zm33.322 13.567v-3.865h7.229v3.865Zm-3.85-12.832 4.512-4.512 2.733 2.732-4.517 4.513Zm-10.1-1.116V.5h3.866v7.229Z"
  })));
};
export default SvgPromos;